export const FETCH_AUDIT = 'audit/FETCH_AUDIT';
export const FETCH_AUDIT_DATA = 'audit/FETCH_AUDIT_DATA';
export const FETCH_AUDIT_ERROR = 'audit/FETCH_AUDIT_ERROR';
